import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { IcArrowRight } from '@quizzach/assets';
import { Navigation } from '@quizzach/components';
import { RoutePath } from '@quizzach/interfaces';
import { Reveal } from '@quizzach/motion';
import { FRow, InfoPage, InfoRows, PageHead } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';

type HubLink = {
	label: string;
	to?: RoutePath;
	href?: string;
	blank?: boolean;
};

export const Info = () => {
	const { t } = useTranslation();

	useEffect(() => {
		scrollToTop();
	}, []);

	const links: HubLink[] = [
		{ label: t('info.aboutUs'), to: RoutePath.AboutUs },
		{ label: t('info.faq'), to: RoutePath.Faq },
		{ label: t('info.contact'), href: 'mailto:team@quizzach.com' },
		{ label: t('info.terms'), to: RoutePath.TermsOfUse },
		{ label: t('info.cookiePolicy'), to: RoutePath.CookiePolicy },
		{ label: t('info.privacy'), to: RoutePath.PrivacyPolicy },
		{
			label: t('info.paymentSecurity'),
			to: RoutePath.PaymentProviderSecurity,
		},
		{
			label: t('info.refundPolicy'),
			// full page load on purpose: the static terms page honours the anchor,
			// the SPA route scrolls to top
			href: `${RoutePath.TermsOfUse}#refund-policy`,
		},
		{
			label: t('info.withdrawalForm'),
			href: 'https://quizzach.com/uploads/obrazac_za_jednostrani_raskid.pdf',
			blank: true,
		},
	];

	return (
		<InfoPage>
			<Navigation />

			<PageHead>
				<Reveal as='h1'>{t('nav.infoCenter')}</Reveal>
			</PageHead>

			<Reveal>
				<InfoRows data-id='about-us-container'>
					{links.map((link, index) => {
						const inner = (
							<span className='in'>
								<span className='num'>
									{String(index + 1).padStart(2, '0')}
								</span>
								<h3>{link.label}</h3>
								<span className='arr'>
									<IcArrowRight size={22} />
								</span>
							</span>
						);

						return link.to ? (
							<FRow as={Link} key={link.label} to={link.to}>
								{inner}
							</FRow>
						) : (
							<FRow
								key={link.label}
								href={link.href}
								target={link.blank ? '_blank' : undefined}
								rel={link.blank ? 'noopener noreferrer' : undefined}
							>
								{inner}
							</FRow>
						);
					})}
				</InfoRows>
			</Reveal>
		</InfoPage>
	);
};
